import { i18n } from "../../../../../../../../i18n";
import * as Yup from "yup";
import { AddSubcategoryEntry } from "../../../../../../../../hooks/api/Subcategories";

export type AddSubcategoryFormData = Omit<AddSubcategoryEntry, "order">;

export const initAddSubcategoryFormData: AddSubcategoryFormData = {
  name: "",
  description: "",
};

export const AddSubcategorySchema: Yup.SchemaOf<AddSubcategoryFormData> =
  Yup.object()
    .shape({
      name: Yup.string().required(
        i18n.t("validators.required", { ns: "translation" })
      ),
      description: Yup.string().required(
        i18n.t("validators.required", { ns: "translation" })
      ),
    })
    .noUnknown(true)
    .strict()
    .required();
